import React from 'react';
import { Icon } from '../../../../../../../../../ui-kit';
import { OptionsListElement } from '../../../Blocks/components/common/StyledEditables';

const Trash = () =>
<OptionsListElement>
    <Icon name="trash" color="white" size={24} />
  </OptionsListElement>;


export default Trash;